export default __webpack_public_path__ + "static/media/redamount-icon.99a051cd.svg";